import { useEffect, useState } from 'react';
import { AdvancedFilterButton } from '@/components/common/AdvancedFilter';
import { PageHeader } from '@/components/layout/PageHeader';
import { useDebounce } from '@/hooks/useDebounce';

interface TeacherSubmissionListHeaderProps {
  appliedSearchText: string;
  onSearchApply: (searchText: string) => void;
  isFilterOpen: boolean;
  onFilterToggle: () => void;
  activeFilterCount: number;
}

export function TeacherSubmissionListHeader({
  appliedSearchText,
  onSearchApply,
  isFilterOpen,
  onFilterToggle,
  activeFilterCount,
}: TeacherSubmissionListHeaderProps) {
  const [searchText, setSearchText] = useState(appliedSearchText);
  const [seenAppliedSearchText, setSeenAppliedSearchText] = useState(appliedSearchText);
  const debouncedSearchText = useDebounce(searchText);

  if (appliedSearchText !== seenAppliedSearchText) {
    setSeenAppliedSearchText(appliedSearchText);
    if (appliedSearchText !== debouncedSearchText.trim()) setSearchText(appliedSearchText);
  }

  useEffect(() => {
    onSearchApply(debouncedSearchText);
  }, [debouncedSearchText, onSearchApply]);

  return (
    <PageHeader
      title="Teacher Submissions"
      search={{ value: searchText, onChange: setSearchText, placeholder: 'Teacher name or mobile' }}
      actions={
        <AdvancedFilterButton
          isOpen={isFilterOpen}
          activeCount={activeFilterCount}
          onClick={onFilterToggle}
        />
      }
    />
  );
}
